import { memo } from 'react';
import { Product } from 'shared/types/product/Product';
import DynamicPageBreadcrumbs from './dynamic-page-breadcrumbs';
import StaticPageBreadcrumbs from './static-page-breadcrumbs';
import { BreadcrumbItem } from './types';

export interface BreadcrumbsProps {
  isStaticPage: boolean;
  breadcrumbItems: BreadcrumbItem[];
  product?: Product;
  staticDataAnalytics?: string;
  sectionId?: string;
}

const Breadcrumbs: React.FC<BreadcrumbsProps> = ({
  isStaticPage,
  breadcrumbItems,
  product,
  staticDataAnalytics,
  sectionId,
}) => {
  return (
    <div id={sectionId}>
      {isStaticPage ? (
        <StaticPageBreadcrumbs staticDataAnalytics={staticDataAnalytics} />
      ) : (
        <DynamicPageBreadcrumbs items={breadcrumbItems} product={product} />
      )}
    </div>
  );
};

export default memo(Breadcrumbs);
